import { render, staticRenderFns } from "./ApprovalDeleteModal.vue?vue&type=template&id=183d1e2c&scoped=true"
import script from "./ApprovalDeleteModal.vue?vue&type=script&lang=js"
export * from "./ApprovalDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDeleteModal.vue?vue&type=style&index=0&id=183d1e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d1e2c",
  null
  
)

export default component.exports